import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signup } from '../apiService';
import classes from './Login.module.css';

const SignUp = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    type: ''           // ← role selection added
  });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setNotification(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNotification(null);

    // ── Validation ──
    if (!formData.username || !formData.email || !formData.phone || !formData.password || !formData.confirmPassword || !formData.type) {
      setNotification({ message: 'Please fill in all fields', type: 'error' });
      return;
    }

    if (!formData.email.includes('@')) {
      setNotification({ message: 'Please enter a valid email address', type: 'error' });
      return;
    }

    if (formData.password.length < 6) {
      setNotification({ message: 'Password must be at least 6 characters', type: 'error' });
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setNotification({ message: 'Passwords do not match', type: 'error' });
      return;
    }

    setLoading(true);

    try {
      const response = await signup(
        formData.username,
        formData.email,
        formData.phone,
        formData.password,
        formData.type       // ← pass role to API
      );

      if (response.success) {
        // ── Signup doesn't return a token — redirect to login ──
        // Store email so login page can pre-fill it
        localStorage.setItem('pendingLoginEmail', formData.email);

        setNotification({
          message: response.message || 'Account created successfully! Redirecting to login...',
          type: 'success'
        });

        setTimeout(() => navigate('/'), 1500);  // ← go to login, not dashboard
      }

    } catch (error) {
      setNotification({
        message: error.message || 'Signup failed. Please try again.',
        type: 'error'
      });
      console.error('Signup error:', error);
    } finally {
      setLoading(false);
    }
  };

  const notificationStyle = {
    marginTop: '20px',
    padding: '16px',
    borderRadius: '8px',
    border: notification?.type === 'success' ? '1px solid #86efac' : '1px solid #fca5a5',
    backgroundColor: notification?.type === 'success' ? '#dcfce7' : '#fee2e2',
    color: notification?.type === 'success' ? '#166534' : '#991b1b',
    animation: 'slideDown 0.3s ease-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    fontWeight: 'bold',
    cursor: 'pointer',
    opacity: 0.7,
    marginLeft: '15px',
    color: 'inherit',
  };

  return (
    <div className={classes.signupContainer}>
      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* Left Section */}
      <div className={classes.signupLeftSection}>
        <img src="/Loginbg.png" alt="Signup Background" className={classes.signupImage} />
        <div className={classes.signupLeftText}>
          DIGITAL<br />PRODUCT<br />PASSPORT
        </div>
      </div>

      {/* Right Section */}
      <div className={classes.signupRightSection}>
        <div className={classes.formWrapper}>
          <div className={classes.formContainer}>
            <form className={classes.form} onSubmit={handleSubmit}>

              <input
                type="text"
                name="username"
                placeholder="Username"
                value={formData.username}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
              />

              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
              />

              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
              />

              {/* ── Role selector ── */}
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className={classes.input}
                disabled={loading}
                style={{ cursor: 'pointer' }}
              >
                <option value="" disabled>Select Role</option>
                <option value="Manufacturer">Manufacturer</option>
                <option value="Recycler">Recycler</option>
                <option value="Distributor">Distributor</option>
                <option value="Retailer">Retailer</option>
                <option value="Regulator">Regulator</option>
                <option value="Repair/Refurb">Repair/Refurb</option>
                <option value="Customer">Customer</option>
              </select>

              <button
                type="submit"
                className={classes.signupSubmitBtn}
                disabled={loading}
              >
                {loading ? 'Signing Up...' : 'Sign Up'}
              </button>

            </form>

            {notification && (
              <div style={notificationStyle}>
                <span style={{ fontWeight: 500 }}>{notification.message}</span>
                <button
                  onClick={() => setNotification(null)}
                  style={closeButtonStyle}
                  onMouseEnter={(e) => e.target.style.opacity = '1'}
                  onMouseLeave={(e) => e.target.style.opacity = '0.7'}
                >
                  ×
                </button>
              </div>
            )}
          </div>

          <div className={classes.forgotRow}>
            Already have an account?{' '}
            <span className={classes.forgotLink} onClick={() => navigate('/')}>
              Log In Here
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;